import React from "react"
import { Link } from "gatsby"
import { dateFormatter } from "../../helpers"
import {
  StyledBlogArticleWrapper,
  StyledArticleImageContainer,
  StyledArticleImage,
  StyledArticleContainer,
  StyledArticleReadingInformation,
  StyledArticleDomain,
  StyledSlash,
  StyledArticleReadingTime,
  StyledArticleTitleContainer,
  StyledArticleTitle,
  StyledArticleDescriptionContainer,
  StyledArticleDescription,
  StyledAboutArticleContainer,
  StyledArticleAuthorImage,
  StyledArticleAuthorName,
  StyledArticleCreationDate,
  StyledArticleLink
} from "./styled"

const ArticlePreview = ({ node }) => {
  const creationDate = dateFormatter(node.date);
  return (
    <StyledBlogArticleWrapper>
      <Link aria-label={node.title} to={node.meta_url}>
        <StyledArticleImageContainer>
          <StyledArticleImage
            alt={node.cover.alternativeText}
            src={node.cover.formats.medium?.url}
          />
        </StyledArticleImageContainer>
      </Link>
      <StyledArticleContainer>
        <StyledArticleReadingInformation>
          <StyledArticleDomain>{node.category.name}</StyledArticleDomain>
          <StyledSlash>/</StyledSlash>
          <StyledArticleReadingTime>{node.read_time}</StyledArticleReadingTime>
        </StyledArticleReadingInformation>
        <StyledArticleTitleContainer>
          <StyledArticleLink to={node.meta_url}>
            <StyledArticleTitle>{node.title}</StyledArticleTitle>
          </StyledArticleLink>
        </StyledArticleTitleContainer>

        <StyledArticleDescriptionContainer>
          <StyledArticleDescription>
            {node.exctract_content}
          </StyledArticleDescription>
        </StyledArticleDescriptionContainer>

        <StyledAboutArticleContainer>
          <StyledArticleAuthorImage
            alt={node.author.avatar.alternativeText}
            src={node.author.avatar.formats.thumbnail.url}
          />
          <StyledArticleAuthorName>{node.author.name}</StyledArticleAuthorName>
          <StyledSlash>/</StyledSlash>
          <StyledArticleCreationDate>{creationDate}</StyledArticleCreationDate>
        </StyledAboutArticleContainer>
      </StyledArticleContainer>
    </StyledBlogArticleWrapper>
  )
}

export default ArticlePreview

